import { Wording } from '@/types';

export const ASTROLOGY_WORDING_LT: Wording = {
  components_header_media_content: 'Garso įrašai',
  components_header_media_1: 'Meditacijos',
  components_header_media_2: 'Podcast\'as',
  components_header_text1: 'Vadovai',
  components_header_text2: 'Dienoraštis',
  components_header_members: 'nariai',
  hero_text: 'Tyrinėkite žvaigždes viduje',
  hero_button_text: 'Pradėkite čia',
  components_ressources_section_title: 'IŠTEKLIAI',
  components_ressources_subheader_text: 'Visi įrankiai, kurių jums reikia kosminei įžvalgai ir savęs atradimui',
  components_ressources_span_text: 'Išplėskite savo vidinę visatą naudodami kuruojamą podcast\'ų ir straipsnių derinį. Nesvarbu, ar siekiate kosminės įžvalgos, aiškumo ar dvasinio suderinimo, mūsų ištekliai padeda praktiškai ir prasmingai susisiekti su astrologija.',
  components_ressources_card_1_title: 'Gilūs nardymai',
  components_ressources_card_1_text: 'Pasinerkite į turtingą nuodugnių internetinių transliacijų kolekciją, apimančią astrologiją, tarot, kosminius archetipus ir dvasinį augimą, skirtų išplėsti jūsų supratimą ir pagilinti praktiką.',
  components_ressources_card_2_title: 'Žvaigždžių įžvalgos',
  components_ressources_card_2_text: 'Astrologiniai patarimai ir tinklaraščio įrašai, skirti savimonei ir sielos augimui.',
  components_ressources_link: 'Naršyti toliau',
  components_notes_and_google_title_1: 'Astrologiniai patarimai',
  components_notes_and_google_title_2: 'Kosminė rutina',
  components_notes_and_google_title_3: 'Atspindžiai',
  components_review_google_text: 'Atsiliepimai',
  media_content_section_title: 'AUDIOS',
  media_content_section_subheader_text: 'Mūsų podcast\'as',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Daugiau epizodų',
  text2_section_title: 'BLOGAS',
  text2_section_subheader_text: 'Straipsniai ir įžvalgos',
  text2_section_button_more: 'Įkelti daugiau',
  components_text1_section_title: 'VADOVAI',
  components_text1_subheader_text: '',
  components_text1_span_text: '',
  components_text1_card_1_title: '',
  components_text1_card_1_text: '',
  components_text1_card_3_title: '',
  components_text1_card_3_text: '',
  components_text1_card_2_title: '',
  components_text1_card_2_text: '',
  components_text1_link: 'Peržiūrėti visus vadovus',
  components_footer_text: 'Pažadink savo vidinį kosmosą: tavo kelias, tavo žvaigždės.',
  components_footer_info: 'Informacija',
  components_footer_registration_number: 'Registracijos numeris',
  components_footer_legal: 'Teisinė',
  components_footer_terms: 'Taisyklės ir sąlygos',
  components_footer_privacy: 'Privatumo politika',
  button_load_more: 'Įkelti daugiau',
  page_media_1_content_hero_text: 'Podcast epizodai',
  page_media_content_menu_foundations: 'Pamatai',
  page_media_content_menu_spirituality: 'Dvasingumas',
  page_media_content_menu_tarot: 'Taro',
  page_media_content_menu_psychology: 'Psichologija',
  page_media_content_menu_trends: 'Tendencijos',
  page_media_2_content_hero_text: '2 medija',
  page_text1_hero_text: '',
  page_text1_section_title: '',
  page_text1_subheader_text: '',
  page_text2_hero_text: 'Mūsų tinklaraštis',
  page_text2_section_title: 'Dienoraštis',
  page_text2_subheader_text: 'Straipsniai ir įžvalgos',
  enter_email_title: 'Jei norite tęsti, įveskite savo el. pašto adresą',
  enter_email_placeholder_email: 'El. paštas',
  enter_email_button_enter: 'Įeikite',
  components_login_success_text: 'Prisijungimas sėkmingas!',
  components_card_link_media_content: 'Klausyk dabar',
  components_card_link_text1_content: 'Žiūrėti vadovą',
  components_card_link_text2_content: 'Žiūrėti straipsnį',
  france: 'Prancūzija',
  cyprus: 'Kipras',
  tag_podcast: 'Podcast\'as',
  tag_meditation: 'Meditacija',
  page_media_content_menu_all: 'Visi',
};